var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8237 4.18148C12.8609 3.92893 11.8869 3.73291 10.9043 3.58984C11.0284 4.57898 11.0963 5.59802 11.1114 6.59077H14C13.9844 5.79487 13.9302 4.97229 13.8237 4.18148Z",
    fill: "url(#paint0_linear_2373_22523)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93429 3.4866C3.79809 4.50912 3.72604 5.56246 3.70996 6.58943H6.58928V3.30859C5.71092 3.32205 4.80762 3.38737 3.93429 3.4866Z",
    fill: "url(#paint1_linear_2373_22523)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39082 0.131469C8.74168 0.057668 8.06328 0.0127969 7.41113 0V2.49143C8.247 2.50376 9.10806 2.5582 9.9398 2.64589C9.79991 1.80302 9.61274 0.965235 9.39082 0.131469Z",
    fill: "url(#paint2_linear_2373_22523)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0672 3.48769C9.19351 3.38841 8.28985 3.32584 7.41113 3.3125V6.58894H10.2896C10.2734 5.56259 10.2033 4.50977 10.0672 3.48769Z",
    fill: "url(#paint3_linear_2373_22523)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41113 11.5281V13.9987C8.06705 13.9858 8.74923 13.9406 9.40217 13.8661C9.6228 13.0381 9.808 12.2052 9.94743 11.3672C9.11238 11.4574 8.24873 11.5154 7.41113 11.5281Z",
    fill: "url(#paint4_linear_2373_22523)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60888 0.131523C4.3872 0.964305 4.19932 1.80108 4.05957 2.64313C4.89156 2.55536 5.75313 2.4993 6.58925 2.48686V0C5.93688 0.0127969 5.25829 0.0576406 4.60888 0.131523Z",
    fill: "url(#paint5_linear_2373_22523)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05078 11.3672C4.19021 12.2053 4.37874 13.0381 4.59938 13.8664C5.2518 13.9409 5.93351 13.9861 6.58902 13.9989V11.528C5.75071 11.5153 4.88641 11.4576 4.05078 11.3672Z",
    fill: "url(#paint6_linear_2373_22523)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.176996 4.17576C0.0700273 4.96846 0.0156406 5.79287 0 6.59063H2.88775C2.90284 5.5992 2.97227 4.58143 3.096 3.59375C2.11416 3.73673 1.13898 3.92357 0.176996 4.17576Z",
    fill: "url(#paint7_linear_2373_22523)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69727 7.41016C3.71332 8.44246 3.80467 9.50007 3.94196 10.5269C4.81349 10.6277 5.71409 10.6937 6.58881 10.7073V7.41016H3.69727Z",
    fill: "url(#paint8_linear_2373_22523)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87487 7.41016H0C0.0156406 8.20605 0.0698906 9.02874 0.176449 9.81961C1.14475 10.0758 2.11977 10.278 3.10048 10.4234C2.97557 9.43056 2.88985 8.40771 2.87487 7.41016Z",
    fill: "url(#paint9_linear_2373_22523)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20891 11.2665C2.24321 11.1316 1.28093 10.9578 0.326172 10.7188C0.491875 11.6433 0.638957 12.247 0.8235 12.8942C0.862437 13.0306 0.96957 13.1378 1.10604 13.1767C1.92567 13.4104 2.69821 13.5894 3.70799 13.7489C3.49969 12.9265 3.33986 12.0978 3.20891 11.2665Z",
    fill: "url(#paint10_linear_2373_22523)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7892 11.2679C10.6583 12.0987 10.5002 12.9268 10.292 13.7486C11.3027 13.589 12.0743 13.4101 12.8934 13.1765C13.0299 13.1376 13.1371 13.0304 13.176 12.8939C13.3589 12.2525 13.507 11.6475 13.674 10.7148C12.7182 10.9542 11.7556 11.1329 10.7892 11.2679Z",
    fill: "url(#paint11_linear_2373_22523)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10619 0.825203C0.969742 0.864141 0.862582 0.971273 0.823645 1.10775C0.640496 1.74997 0.492293 2.35536 0.325195 3.28948C1.27419 3.05446 2.23565 2.88539 3.20228 2.7528C3.3338 1.91406 3.51465 1.08032 3.72495 0.25C2.70503 0.410207 1.92593 0.591414 1.10619 0.825203Z",
    fill: "url(#paint12_linear_2373_22523)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41113 7.41018V10.7042C8.28572 10.6905 9.18632 10.6269 10.0579 10.5261C10.1951 9.49955 10.2884 8.44233 10.3044 7.41016H7.41113V7.41018Z",
    fill: "url(#paint13_linear_2373_22523)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1269 7.41018C11.1119 8.40891 11.0245 9.43272 10.8994 10.4267C11.8803 10.2813 12.855 10.0731 13.8237 9.8169C13.93 9.02688 13.9843 8.20518 13.9999 7.41016H11.1269V7.41018Z",
    fill: "url(#paint14_linear_2373_22523)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1759 1.10794C13.137 0.971492 13.0298 0.864332 12.8934 0.825395C12.0716 0.591004 11.2919 0.409906 10.2734 0.25C10.4834 1.07939 10.6633 1.91225 10.7947 2.74993C11.7614 2.88238 12.7239 3.04724 13.6731 3.2822C13.5071 2.35626 13.3599 1.75311 13.1759 1.10794Z",
    fill: "url(#paint15_linear_2373_22523)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2373_22523",
    x1: 12.4522,
    y1: 3.58984,
    x2: 12.4522,
    y2: 6.59077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2373_22523",
    x1: 5.14962,
    y1: 3.30859,
    x2: 5.14962,
    y2: 6.58943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2373_22523",
    x1: 8.67547,
    y1: 0,
    x2: 8.67547,
    y2: 2.64589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2373_22523",
    x1: 8.85036,
    y1: 3.3125,
    x2: 8.85036,
    y2: 6.58894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2373_22523",
    x1: 8.67928,
    y1: 11.3672,
    x2: 8.67928,
    y2: 13.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2373_22523",
    x1: 5.32441,
    y1: 0,
    x2: 5.32441,
    y2: 2.64313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2373_22523",
    x1: 5.3199,
    y1: 11.3672,
    x2: 5.3199,
    y2: 13.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2373_22523",
    x1: 1.548,
    y1: 3.59375,
    x2: 1.548,
    y2: 6.59063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2373_22523",
    x1: 5.14304,
    y1: 7.41016,
    x2: 5.14304,
    y2: 10.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2373_22523",
    x1: 1.55024,
    y1: 7.41016,
    x2: 1.55024,
    y2: 10.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2373_22523",
    x1: 2.01708,
    y1: 10.7188,
    x2: 2.01708,
    y2: 13.7489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2373_22523",
    x1: 11.983,
    y1: 10.7148,
    x2: 11.983,
    y2: 13.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2373_22523",
    x1: 2.02507,
    y1: 0.25,
    x2: 2.02507,
    y2: 3.28948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2373_22523",
    x1: 8.85778,
    y1: 7.41016,
    x2: 8.85778,
    y2: 10.7042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2373_22523",
    x1: 12.4496,
    y1: 7.41016,
    x2: 12.4496,
    y2: 10.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2373_22523",
    x1: 11.9732,
    y1: 0.25,
    x2: 11.9732,
    y2: 3.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CE8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AFFD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.771f6eca8b3e8219ab999b23c892750a.svg";
export { ForwardRef as ReactComponent };